import React, { useState } from 'react';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'assets/images/back-icon.svg';
import BonusForm from './BonusForm';
import CustomLoader from 'components/CustomOverlay';
import './style.scss';

const Index = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || location.state?.token;
    const isTab = location.state?.token;
    const [submitLoader, setSubmitLoader] = useState(false);

    return (
        <CustomLoader active={submitLoader}>
            <div className='bonus-modal'>
                {isTab && (
                    <div className='back-navigation'>
                        <span onClick={() => navigate(-1)}>
                            <BackIcon /> Back
                        </span>
                    </div>
                )}
                <div className='headline-2'>Award a Bonus</div>
                <BonusForm authToken={token} setSubmitLoader={setSubmitLoader} />
            </div>
        </CustomLoader>
    );
};

export default Index;
